'use client';

import React from 'react';
import styles from './AccountsPage.module.css';
import { useAccounts } from './useAccounts';
import { AccountItem } from './types';
import AccountRow from './AccountRow';
import AccountRowSkeleton from './AccountRowSkeleton';

const AccountsPage: React.FC = () => {
  const { isError, isPlaceholderData, isLoading, data, pagination } =
    useAccounts();

  const showLoading = isPlaceholderData || isLoading;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.title}>Top accounts</h1>
      </div>

      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Rank</th>
              <th>Address</th>
              <th>Balance</th>
              <th>Verified</th>
              <th>Txn count</th>
            </tr>
          </thead>
          <tbody>
            {showLoading ? (
              Array.from({ length: 10 }).map((_, i) => (
                <AccountRowSkeleton key={i} />
              ))
            ) : isError ? (
              <tr>
                <td colSpan={5}>
                  <div className={styles.emptyState}>Failed to load accounts.</div>
                </td>
              </tr>
            ) : !data?.items || data.items.length === 0 ? (
              <tr>
                <td colSpan={5}>
                  <div className={styles.emptyState}>There are no accounts.</div>
                </td>
              </tr>
            ) : (
              data.items.map((item: AccountItem, index: number) => {
                const rank = (pagination.page - 1) * 50 + index + 1;
                return <AccountRow key={item.hash} item={item} rank={rank} />;
              })
            )}
          </tbody>
        </table>
      </div>

      {!showLoading && data?.items && data.items.length > 0 && (
        <div className={styles.pagination}>
          <button
            className={styles.pageButton}
            disabled={!pagination.canGoBackwards}
            onClick={pagination.onPrevPageClick}
          >
            &lt; Prev
          </button>
          <button
            className={`${styles.pageButton} ${styles.pageButtonActive}`}
          >
            {pagination.page}
          </button>
          <button
            className={styles.pageButton}
            disabled={!pagination.hasNextPage}
            onClick={pagination.onNextPageClick}
          >
            Next &gt;
          </button>
        </div>
      )}
    </div>
  );
};

export default AccountsPage;
